import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'react-toastify/dist/ReactToastify.css';
import 'preline/dist/preline.js';
import feLog from './utils/feLog';

window.addEventListener("error", (event) => {
  feLog({
    src: "frontend",
    step: "window.error",
    msg: event.message,
    stack: event.error?.stack,
    href: window.location.href,
  });
});

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  feLog({
    src: "frontend",
    step: "unhandledrejection",
    msg: reason?.message || String(reason),
    stack: reason?.stack,
    href: window.location.href,
  });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
    <App />
  //</React.StrictMode>
);
